"use client";

import { useState } from "react";
import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useAssignDialog } from "../Providers/AssignDialogContext";
import { User } from "@/api/users";
import { EmailCadence } from "@/interfaces/campaign";

interface AssignFormContentProps {
  users: User[];
}

export default function AssignFormContent({ users }: AssignFormContentProps) {
  const {
    emailCadence,
    selectedAssignUsers,
    setEmailCadence,
    setSelectedAssignUsers,
  } = useAssignDialog();
  const [searchValue, setSearchValue] = useState("");

  const userOptions: User[] = users;

  return (
    <>
      <FormControl className="mt-1 pb-4" fullWidth>
        <Autocomplete
          multiple
          fullWidth
          id="multiple-users-tags"
          value={selectedAssignUsers}
          onChange={(event, newValue) => setSelectedAssignUsers(newValue)}
          inputValue={searchValue}
          onInputChange={(event, newValue) => setSearchValue(newValue)}
          options={userOptions}
          getOptionLabel={(user) => user.email}
          renderInput={(params) => <TextField {...params} label="Users" />}
        />
      </FormControl>
      {selectedAssignUsers.map((user) => (
        <input key={user.id} type="hidden" name="userIds" value={user.id} />
      ))}
      <FormControl fullWidth className="pb-4">
        <InputLabel id="notification-cadence">Notify By Email</InputLabel>
        <Select
          labelId="notification-cadence"
          id="notification-cadence"
          value={emailCadence}
          label="Notify By Email"
          onChange={(e) => setEmailCadence(e.target.value as EmailCadence)}
          name="emailCadence"
        >
          <MenuItem value={EmailCadence.Unsubscribed}>Unsubscribed</MenuItem>
          <MenuItem value={EmailCadence.Daily}>Daily</MenuItem>
          <MenuItem value={EmailCadence.Weekly}>Weekly</MenuItem>
        </Select>
      </FormControl>
    </>
  );
}
